import Auth, { configureAuth } from '@kargotech/tms-core/auth';

configureAuth({
  region: process.env.REACT_APP_AWS_COGNITO_REGION,
  userPoolId: process.env.REACT_APP_AWS_COGNITO_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID,
});

export default Auth;
